// AUTO-GENERATED from content/roi/2026-11/source/data/burden.json and wages.json by scripts/generate-burden.mjs.
// DO NOT EDIT BY HAND. Run `node scripts/generate-burden.mjs` to regenerate; CI fails on drift.
// The comparison figures every pricing headline and Prest0n draw (R13b): what the headline role (the average full-time employee) costs to employ, all overhead in, at the center estimate, and each industry's own role. Dependency-free: the same file serves the pages (src/roi/) and the server (functions/src/billing/). The itemized lines are /roi/savings'.

export const BURDENED_HIRE = {
  role: "office_generalist",
  roleLabel: "average full-time employee",
  annualUsd: 132133,
  monthlyUsd: 11011,
  asOf: "2026-11-02",
} as const;

/** What this many of the headline role cost a month, fully burdened: the annual center x n / 12, rounded once at the end. */
export function burdenedHireMonthlyUsd(people: number): number {
  return Math.round((BURDENED_HIRE.annualUsd * people) / 12);
}

/** One industry's own comparison role, all overhead in, at the center estimate. */
export interface IndustryHire {
  readonly role: string;
  readonly roleLabel: string;
  readonly annualUsd: number;
  readonly monthlyUsd: number;
}

/** Each industry's own role (burden.json industryRoles), in the site's order: the ROI index's cards and the calculator's roles. */
export const INDUSTRY_HIRES: Readonly<Record<string, IndustryHire>> = {
  "law": { role: "paralegal", roleLabel: "paralegal", annualUsd: 110723, monthlyUsd: 9227 },
  "marketing": { role: "marketing_specialist", roleLabel: "marketing specialist", annualUsd: 131796, monthlyUsd: 10983 },
  "finance": { role: "bookkeeper", roleLabel: "bookkeeper", annualUsd: 95013, monthlyUsd: 7918 },
  "real-estate": { role: "re_admin", roleLabel: "real estate administrative assistant", annualUsd: 89691, monthlyUsd: 7474 },
  "insurance": { role: "insurance_clerk", roleLabel: "insurance claims and policy clerk", annualUsd: 93923, monthlyUsd: 7827 },
  "property-management": { role: "property_manager", roleLabel: "property manager", annualUsd: 114289, monthlyUsd: 9524 },
  "general": { role: "office_generalist", roleLabel: "average full-time employee", annualUsd: 132133, monthlyUsd: 11011 },
};
